export default "<!-- <p>Current: {{currentPlatform}} || Platforms: {{platforms}}</p> -->\n<p>Redirecting...</p>\n";